import EditAlarm from '@/pages/Alarms/Edit';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.EditAlarm = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function () {
        const modelData = this.model ? this.model.toJSON() : {};

        this.reactRoot = createRoot(document.getElementById(this.id));
        this.reactRoot.render(<EditAlarm modelData={modelData}/>);
    },

    onClose: function () {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
        }
    }
});
